module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.sceneryList), function(scenery) {
    return _c('div', {
      staticClass: "bg-white p10 mt10 br4 cursor"
    }, [_c('div', {
      staticClass: "row",
      on: {
        "click": function($event) {
          return _vm.$router.push('/cgd/by/scenery/detail/' + scenery.id)
        }
      }
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "pull-left"
    }), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('div', [_c('span', {
      staticClass: "f15"
    }, [_vm._v(_vm._s(scenery.name))])]), _vm._v(" "), _c('div', {
      staticClass: "mv5"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(scenery.description) + "\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "mv5"
    }, [_c('span', [_vm._v("编号：" + _vm._s(scenery.id))])])])])])])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mb10"
  }, [_c('div', {
    staticClass: "col-xs-12 clearfix"
  }, [_c('div', {
    staticClass: "pull-left f24"
  }, [_c('i', {
    staticClass: "fa fa-fire text-success"
  }), _vm._v(" "), _c('span', [_vm._v("定制页面列表")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 mt30"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n\t\t\t\t以下展示的是网站中特殊的自定义页面，这些页面可以在 【菜单/专题】中进行链接。如果要添加更多特殊页面或者修改已有的页面，请联系程序员进行操作。\n\t\t\t")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-6843b049"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/scenery/List.vue
// module id = 998
// module chunks = 1